module.exports = __webpack_public_path__ + "img/backward-item-1.4d365bd6.svg";